export const enum ALGOLIA_EVENT_NAME {
  productClicked = 'Product Clicked',
  productConverted = 'Product Converted',
  productAddedToCart = 'Product Added to Cart',
  productPurchased = 'Product Purchased',
  productDetailViewed = 'Product Detail Page Viewed',
  hitsViewed = 'Hits Viewed',
  filterApplied = 'Filter Applied',
  filterViewed = 'Filter Viewed',
}

/** Algolia Insights limits on the number of objectIDs or filters in one event. */
export const ALGOLIA_EVENT_MAX_OBJECT_IDS = 20;
export const ALGOLIA_EVENT_MAX_FILTERS = 10;
